import React from 'react';
import { services } from '../mock';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

const ServicesSection = ({ setActiveSection, isFullPage }) => {
  // ❌ हटाए जाने वाले services
  const blocked = [
    "Herbal Potli Massage",
    "Hot Stone Massage",
    "VIP Room with Jacuzzi",
    "Body Polish",
    "Kansa Wand Massage",
    
  ];

  const filteredServices = services.filter(
    (service) => !blocked.includes(service.title)
  );

  return (
    <section id="services" className="bg-white">

      {/* ⭐ FULL PAGE में दिखेगा */}
      {isFullPage && (
        <div className="relative w-full h-[320px] md:h-[380px]">
          <img 
            src="/gallary/g3.jpg"
            alt="Services Banner"
            className="absolute inset-0 w-full h-full object-cover"
          />

          <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white">
              Our Services
            </h1>
          </div>

          <div className="absolute bottom-0 left-0 w-full bg-black/40 backdrop-blur-sm py-3 px-6 flex justify-between items-center text-white">
            <h2 className="text-xl md:text-2xl font-semibold">Services</h2>

            <div className="flex items-center gap-2 text-sm md:text-base">
              <button
                onClick={() => setActiveSection("home")}
                className="hover:text-amber-400 transition"
              >
                Home
              </button>

              <span>›</span>
              <span className="text-amber-300">Services</span>
            </div>
          </div>
        </div>
      )}

      {/* TITLE — केवल HOME में दिखाना है */}
      {!isFullPage && (
        <div className="text-center py-10">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            Our <span className="text-amber-900">Spa Services</span>
          </h2>
          <p className="text-gray-600 mt-3">
            Experience a wide range of premium wellness therapies
          </p>
          <div className="w-24 h-1 bg-amber-900 mx-auto mt-3"></div>
        </div>
      )}

      {/* Service Cards */}
      <div className="container mx-auto px-4 pb-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

        {filteredServices.map((service) => (
          <Card
            key={service.id}
            className="group overflow-hidden hover:shadow-2xl transition-all duration-300 border-0"
          >
            <div className="relative overflow-hidden h-64">
              <img
                src={service.image}
                alt={service.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
            </div>

            <CardContent className="p-6">
              {/* Heading Click = Individual Page */}
              <h3
                className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-amber-900 transition-colors cursor-pointer"
                onClick={() => setActiveSection("services")}
              >
                {service.title}
              </h3>

              <p className="text-gray-600 mb-4 leading-relaxed">
                {service.description}
              </p>

              {/* Book Button */}
              <Button
                className="bg-amber-900 hover:bg-amber-800 text-white w-full transition-all hover:scale-105"
                onClick={() => setActiveSection("booking")}
              >
                Book Now
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>

    </section>
  );
};

export default ServicesSection;
